<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-user-list">
    <vs-card>
      <vs-table selected search stripe :data="dispensas">
        <template slot="header">
          <vs-button
            v-if="canAddAttendance"
            @click="popupAdd = true"
            icon-pack="feather"
            icon="icon-plus"
            color="primary"
            type="border"
            class="mb-2"
            >Adicionar Dispensa</vs-button
          >
        </template>
        <template slot="thead">
          <vs-th sort-key="name">Nome</vs-th>
          <vs-th sort-key="email">Descrição</vs-th>
          <vs-th sort-key="email">Data Inicial</vs-th>
          <vs-th sort-key="email">Data Final</vs-th>
          <!-- <vs-th sort-key="email">Hora Inicio/Fim</vs-th> -->
          <!-- <vs-th sort-key="email">Dedução</vs-th> -->
          <vs-th sort-key="email">Duração</vs-th>
          <vs-th sort-key="email">Comprovativo</vs-th>
          <vs-th sort-key="email">Estado</vs-th>
          <vs-th sort-key="email">Detalhes</vs-th>
          <!-- <vs-th sort-key="email">Estado</vs-th> -->
          <!-- <vs-th sort-key="birth_date">Data de Nascimento</vs-th> -->
          <vs-th></vs-th>
          <!-- <vs-th sort-key="id">Nro</vs-th> -->
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].name">
              {{ data[indextr].employee.user.name }}
              {{ data[indextr].employee.user.surname }}
            </vs-td>

            <vs-td>{{ data[indextr].reason }}</vs-td>
            <vs-td :data="data[indextr].amount">
              {{ data[indextr].start_date }} às {{ formatTimeWithoutSeconds(data[indextr].start_time) }}
            </vs-td>
            <vs-td :data="data[indextr].amount">  
              {{ data[indextr].end_date }} às {{ formatTimeWithoutSeconds(data[indextr].end_time) }}
            </vs-td>
            <!-- <vs-td>
              {{ data[indextr].start_time }} ate <br />
              {{ data[indextr].end_time }}
            </vs-td> -->
            <!-- <vs-td :data="data[indextr].date">
              <span v-if="data[indextr].deduct_in == 'vacation'">Férias</span>
              <span v-if="data[indextr].deduct_in == 'salary'">Salário</span>
            </vs-td> -->

            <vs-td :data="data[indextr].date">
              {{ converterSegundos(data[indextr].total_diff_seconds) }}
            </vs-td>
            <vs-td>
              <vs-button
                v-if="data[indextr].attachment"
                target="_blank"
                size="small"
                iconPack="feather"
                color="success"
                icon="icon-download"
                :href="data[indextr].attachment"
              >
                Baixar
              </vs-button>
              <span v-else>Sem Anexo</span>
            </vs-td>
            <vs-td>
              <vs-chip
                v-if="data[indextr].status == 'created'"
                class="font-bold whitespace-no-wrap"
              >
                <div
                  class="h-2 w-2 rounded-full mr-1"
                  :class="'bg-primary'"
                ></div>
                <span>Criado</span>
              </vs-chip>

              <vs-chip
                v-if="data[indextr].status == 'pending'"
                class="font-bold whitespace-no-wrap"
              >
                <div
                  class="h-2 w-2 rounded-full mr-1"
                  :class="'bg-warning'"
                ></div>
                <span>pendente</span>
              </vs-chip>

              <vs-chip
                v-if="data[indextr].status == 'submeted'"
                class="font-bold whitespace-no-wrap"
              >
                <div
                  class="h-2 w-2 rounded-full mr-1"
                  :class="'bg-primary'"
                ></div>
                <span>Submetido</span>
              </vs-chip>
              <vs-chip
                v-if="data[indextr].status == 'approved'"
                class="font-bold whitespace-no-wrap"
              >
                <div
                  class="h-2 w-2 rounded-full mr-1"
                  :class="'bg-success'"
                ></div>
                <span>Aprovado</span>
              </vs-chip>
              <vs-chip
                v-if="data[indextr].status == 'rejected'"
                class="font-bold whitespace-no-wrap"
              >
                <div
                  class="h-2 w-2 rounded-full mr-1"
                  :class="'bg-warning'"
                ></div>
                <span>Rejeitado</span>
              </vs-chip>
              <vs-chip
                v-if="data[indextr].status == 'canceled'"
                class="font-bold whitespace-no-wrap"
              >
                <div
                  class="h-2 w-2 rounded-full mr-1"
                  :class="'bg-danger'"
                ></div>
                <span>Cancelado</span>
              </vs-chip>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <vs-row>
                <!-- <vs-button
                  :disabled="!canUpdatePayroll"
                  color="primary"
                  size="small"
                  hover:text-danger
                  icon-pack="feather"
                  icon="icon-edit"
                  @click="popupOpenEdit(tr)"
                >
                </vs-button> -->
                <!-- <vs-button :disabled="!canDeletePayroll" class="ml-2" color="danger"  type="border" size="small" icon-pack="feather" icon="icon-trash" @click="removeData(tr)"></vs-button> -->
                <!-- <vs-button
                  :disabled="!canDeletePayroll"
                  class="ml-2"
                  color="success"
                  size="small"
                  icon-pack="feather"
                  icon="icon-eye"
                  @click="getOpenApprove(tr)"
                ></vs-button> -->
              </vs-row>
              <vs-button
                  class="ml-1 mb-1"
                  color="success"
                  size="small"
                  icon-pack="feather"
                  icon="icon-log-in"
                  :to="{
                    name: 'dispensaDetails',
                    params: {
                      dispensaName: tr.employee.user.name ,
                      dispensaLastName: tr.employee.user.surname,
                      dispensaId: tr.id,
                    },
                  }"
                >
                  Entrar
                </vs-button>
              <!-- <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteData(tr.id)" /> -->
            </vs-td>

            <!-- <vs-td :data="data[indextr].id">
          {{ data[indextr].id }}
        </vs-td> -->
          </vs-tr>
        </template>
      </vs-table>
      <vs-pagination
        class="mt-3"
        :total="totalPage"
        @change="getEmployees"
        v-model="currentPage"
      ></vs-pagination>
      <div
        style="height: 50px"
        id="div-with-loading"
        class="vs-con-loading__container"
      ></div>
    </vs-card>

    

    <vs-popup class="holamundo" title="Aprovações" :active.sync="popupApprove">
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="vx-row mb-4 ml-3">
            <vs-button
              size="small"
              color="primary"
              class="mr-2"
              icon-pack="feather"
              icon="icon-check-circle"
              @click="
                status = `approved`;
                saveApprove();
              "
            >
              Submeter
            </vs-button>
            <vs-button
              size="small"
              color="success"
              class="mr-2"
              icon-pack="feather"
              icon="icon-check-circle"
              @click="
                status = `approved`;
                saveApprove();
              "
            >
              Aprovar
            </vs-button>
            <vs-button
              size="small"
              color="warning"
              class="mr-2"
              icon-pack="feather"
              icon="icon-x-circle"
              @click="
                status = `rejected`;
                saveApprove();
              "
            >
              Reprovar
            </vs-button>
            <vs-button
              size="small"
              color="danger"
              :disabled="!canAddPayroll"
              class="mr-2"
              @click="
                status = `canceled`;
                saveApprove();
              "
            >
              Cancelar
            </vs-button>
          </div>

          <div class="vx-col w-full">
            <ul class="vx-timeline">
              <li v-for="historico in aprovacaoSelecionada" v-bind:key="id">
                <div
                  v-if="historico.status == 'rejected'"
                  class="timeline-icon bg-warning"
                >
                  <feather-icon
                    icon="AlertCircleIcon"
                    svgClasses="text-white stroke-current w-5 h-5"
                  />
                </div>
                <div
                  v-if="historico.status == 'submeted'"
                  class="timeline-icon bg-success"
                >
                  <feather-icon
                    icon="CheckCircleIcon"
                    svgClasses="text-white stroke-current w-5 h-5"
                  />
                </div>
                <div
                  v-if="historico.status == 'canceled'"
                  class="timeline-icon bg-danger"
                >
                  <feather-icon
                    icon="XCircleIcon"
                    svgClasses="text-white stroke-current w-5 h-5"
                  />
                </div>
                <div
                  v-if="historico.status == 'approved'"
                  class="timeline-icon bg-primary"
                >
                  <feather-icon
                    icon="ArrowUpIcon"
                    svgClasses="text-white stroke-current w-5 h-5"
                  />
                </div>
                <div
                  v-if="historico.status == 'pending'"
                  class="timeline-icon bg-dark"
                >
                  <feather-icon
                    icon="FileTextIcon"
                    svgClasses="text-white stroke-current w-5 h-5"
                  />
                </div>
                <div class="timeline-info">
                  <p class="font-semibold">
                    <span v-if="historico.status == `rejected`">Reprovado</span>
                    <span v-if="historico.status == `submeted`">Submetido</span>
                    <span v-if="historico.status == `canceled`">Cancelado</span>
                    <span v-if="historico.status == `approved`">Aprovado</span>
                    por {{ historico.user.name }} {{ historico.user.surname }}
                  </p>
                  <span class="activity-desc">{{ historico.observation }}</span>
                </div>
                <small class="text-bold activity-e-time"
                  >Data: {{ historico.created_at.slice(0, 10) }} às
                  {{ historico.created_at.slice(11, 16) }}</small
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </vs-popup>

    <vs-popup
      class="holamundo"
      title="Actualizar Dispensa"
      :active.sync="popupEdit"
    >
      <div class="vx-row">
        <div class="vx-col w-full mb-2">
          <label class="mt-8" for="">Dispensa</label>
          <v-select
            v-validate="'required'"
            v-model="type"
            :reduce="(options) => options.id"
            :options="[
              { id: 1, label: 'Doença do trabalhador' },
              { id: 2, label: 'Doença do dependente' },
              { id: 3, label: 'Acidente do trabalhador' },
              { id: 4, label: 'Acidente do menor' },
              { id: 5, label: 'Maternidade' },
              { id: 6, label: 'Paternidade' },
            ]"
          >
          </v-select>
          <span class="text-danger text-sm" v-show="errors.has('motivo')">{{
            errors.first("motivo")
          }}</span>
        </div>

        <div class="vx-col w-1/2 mb-5">
          <label for="">Data de início</label> <br />

          <vs-input class="w-full" type="date" v-model="start_date"></vs-input>
        </div>
        <div class="vx-col w-1/2 mb-5">
          <label for="">Data de término</label> <br />

          <vs-input class="w-full" type="date" v-model="end_date"></vs-input>
        </div>
        <div class="vx-col w-1/2 mb-5">
          <label for="">Hora de início</label> <br />

          <vs-input class="w-full" type="time" v-model="start_time"></vs-input>
        </div>

        <div class="vx-col w-1/2 mb-5">
          <label for="">Hora de término</label> <br />
          <vs-input class="w-full" type="time" v-model="end_time"></vs-input>
        </div>
        <div class="vx-col w-full mb-5">
          <label for="">Deduzir em:</label> <br />

          <select
            v-model="deduct_in"
            class="w-full pl-3 pr-10 py-2 transition duration-100 ease-in-out border rounded shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <option value="vacation">Nas ferias</option>
            <option value="salary">No salario</option>
          </select>
        </div>

        <div class="vx-col w-full mb-2">
          <label class="mt-8" for="">Descrição</label>
          <vs-input class="w-full mt-2 mb-5" type="text" v-model="reason" />
        </div>

        <div class="vx-col w-full mb-2">
          <div class="flex flex-wrap items-center flex-start">
            <vs-button class="ml-auto mt-2" @click="saveData">Salvar</vs-button>
            <vs-button class="ml-4 mt-2" type="border" color="warning"
              >Cancelar</vs-button
            >
          </div>
        </div>
      </div>
    </vs-popup>

    <vs-popup
      class="holamundo"
      title="Adicionar Dispensa"
      :active.sync="popupAdd"
    >
      <div class="vx-row">
        <div class="vx-col w-full mb-2">
          <label class="mt-8" for=""
            >Funcionario:
            <strong
              >{{ selectedEmployee.name }}
              {{ selectedEmployee.surname }}</strong
            ></label
          >

          <v-select
            :label="'name'"
            class="mt-2"
            v-validate="'required'"
            v-model="selectedEmployee"
            :options="employees"
          >
          </v-select>
        </div>

        <div class="vx-col w-1/2 mb-5">
          <label for="">Data de início</label> <br />

          <vs-input class="w-full" type="date" v-model="start_date"></vs-input>
        </div>
        <div class="vx-col w-1/2 mb-5">
          <label for="">Data de término</label> <br />

          <vs-input class="w-full" type="date" v-model="end_date"></vs-input>
        </div>
        <div class="vx-col w-1/2 mb-5">
          <label for="">Hora de início</label> <br />

          <vs-input class="w-full" type="time" v-model="start_time"></vs-input>
        </div>

        <div class="vx-col w-1/2 mb-5">
          <label for="">Hora de término</label> <br />
          <vs-input class="w-full" type="time" v-model="end_time"></vs-input>
        </div>
        <div class="vx-col w-full mb-5">
          <label for="">Dedução</label> <br />

          <select
            v-model="deduct_in"
            class="w-full pl-3 pr-10 py-2 transition duration-100 ease-in-out border rounded shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <option value="vacation">Nas ferias</option>
            <option value="salary">No salario</option>
          </select>
        </div>

        <div class="vx-col w-full mb-2">
          <label class="mt-8" for="">Descrição</label>
          <textarea
            class="w-full mt-2 mb-5 p-2 border rounded resize-y"
            v-model="reason"
            rows="4"
            style="border-color: #ccc"
            placeholder="Insira a descrição"
          ></textarea>
        </div>

        <div class="vx-col w-full mb-2">
          <label class="mt-8" for="">Comprovativo</label>
          <vs-input
            class="w-full mt-2 mb-2"
            type="file"
            name="file"
            @change="previewImage"
          />
        </div>
        
        <div class="vx-col w-full mb-2">
          <div class="flex flex-wrap items-center flex-start">
            <vs-button class="ml-auto mt-2" @click="saveData">Salvar</vs-button>
            <vs-button class="ml-4 mt-2" type="border" @click="popupAdd = false" color="warning"
              >Cancelar</vs-button
            >
          </div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import vSelect from "vue-select";
import http from "../../../../http-common";
import { PermissionsMixin } from "../../../mixins/permissions";
import VxTimeline from "@/components/timeline/VxTimeline.vue";
// Store Module

// Cell Renderer

export default {
  mixins: [PermissionsMixin],
  components: {
    vSelect,

    VxTimeline,
  },
  data() {
    return {
      attachment: "",
      dispensa: [],
      historico: [],
      aprovacaoSelecionada: [],
      aprovacao: [],
      aprovacoes: [],
      dispensas: [],
      deduct_in: "",
      start_date: "",
      start_time: "",
      end_date: "",
      end_time: "",
      reason: "",
      totalPage: "",
      currentPage: "1",
      paginate: 50,
      amount: "",
      desconto: [],
      selectedEmployee: [],
      employees: [],
      popupAdd: false,
      popupEdit: false,
      name: "",
      abbreviation: "",
      type: "",
      components: [],
      component: [
        {
          id: "",
          name: "",
          abbreviation: "",
          type: "",
        },
      ],
      descontos: [],
      date: "",

      currentUser: [],
      dataActual: "",
      month: "",

      popupApprove: false,
    };
  },

  mounted() {
    this.initialize();
  },

  methods: {
    initialize() {
      this.getData();
      this.getEmployees();
    },

    previewImage(event) {
      this.attachment = event.target.files[0];
    },
    popupOpenEdit(dispensa) {
      (this.dispensa = dispensa), (this.popupEdit = true);
    },
    formatTimeWithCustomDay(total_diff_seconds) {
  // Converte a string para um número
  const totalSeconds = Math.abs(parseFloat(total_diff_seconds));

  // Constantes para conversão
  const secondsInMinute = 60;
  const secondsInHour = 60 * secondsInMinute;
  const secondsInCustomDay = 8 * secondsInHour; // Um "dia" de 8 horas em segundos

  // Calcula o número de dias, horas e minutos
  const days = Math.floor(totalSeconds / secondsInCustomDay);
  const remainingSecondsAfterDays = totalSeconds % secondsInCustomDay;

  const hours = Math.floor(remainingSecondsAfterDays / secondsInHour);
  const remainingSecondsAfterHours = remainingSecondsAfterDays % secondsInHour;

  const minutes = Math.floor(remainingSecondsAfterHours / secondsInMinute);

  // Montando a string condicionalmente
  let timeString = '';
  
  if (days > 0) {
    timeString += `${days} dia${days > 1 ? 's' : ''}`; // Exibe dias se houver
  }
  
  if (hours > 0) {
    if (timeString) timeString += ', ';
    timeString += `${hours} hora${hours > 1 ? 's' : ''}`; // Exibe horas se houver
  }
  
  if (minutes > 0 || timeString === '') { // Exibe minutos se houver ou se não houver outras unidades
    if (timeString) timeString += ', ';
    timeString += `${minutes} minuto${minutes > 1 ? 's' : ''}`; // Exibe minutos se houver
  }

  return timeString;
},

formatTimeWithoutSeconds(timeString) {
  // Verifica se a string está no formato esperado
  if (!timeString || typeof timeString !== "string") {
    return "";
  }

  // Divide a string em partes (HH, mm, ss)
  const timeParts = timeString.split(":");

  // Retorna apenas as duas primeiras partes (HH:mm)
  return timeParts.length >= 2 ? `${timeParts[0]}:${timeParts[1]}` : timeString;
},

converterSegundos(total_diff_seconds) {
  return this.formatTimeWithCustomDay(total_diff_seconds);
},


    getEmployees() {
      //  this.$vs.loading()

      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
        params: {
          page: this.currentPage,
          paginate: this.paginate,
          status: 1,
        },
      };

      http
        .get("/employees/employees", config)
        .then((result) => {
          //  this.$vs.loading.close()
          this.employees = result.data.Employees.data.reverse();
          (this.currentPage = "1"),
            (this.totalPage = result.data.Employees.last_page);
          this.total = result.data.Employees.total;
        })
        .catch((error) => {
          error;
          if (error.response.status == 401) {
            this.$router.push("/").catch(() => {});
          }
        });
    },

    async saveApprove() {
      this.$vs.loading();

      try {
        let token = localStorage.getItem("token");
        let config = {
          headers: {
            authorization: "Bearer " + token,
          },
        };
        const data = {
          status: this.status,
        };

        // Certifique-se de que this.aprovacao está definido
        if (this.aprovacao.id) {
          await http.post(
            `/attendances/waivers/approvals/${this.aprovacao.id}`,
            data,
            config
          );

          // Recupere os dados atualizados após a operação de salvar
          await this.getData();

          // Feche o carregamento
          this.$vs.loading.close();
          this.popupApprove = false;
        } else {
          console.error("ID de aprovação não definido.");
          this.$vs.loading.close();
        }
      } catch (error) {
        // Lida com erros
        console.error(error);
        if (error.response && error.response.status === 401) {
          this.$router.push("/").catch(() => {});
        }
        this.$vs.loading.close();
      }
    },

    getOpenApprove(dados) {
      // Defina this.aprovacao e this.status antes de chamar getApprove()
      this.aprovacao = dados;
      this.status = "submeted"; // Por padrão, defina o status como 'submeted'
      this.popupApprove = true;
      this.getApprove();
    },

    getApprove() {
      this.$vs.loading();

      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };

      // Verifique se this.aprovacao.id está definido antes de fazer a solicitação
      if (this.aprovacao.id) {
        http
          .get(`/attendances/waivers/${this.aprovacao.id}`, config)
          .then((result) => {
            this.$vs.loading.close();
            console.log("Dados recuperados em getApprove():", result.data); // Adicione esta linha para verificar os dados recuperados
            this.aprovacaoSelecionada = result.data.Employee.approvals;
          })
          .catch((error) => {
            error;
            if (error.response.status == 401) {
              this.$router.push("/").catch(() => {});
            }
          });
      } else {
        console.error("ID de aprovação não definido.");
        this.$vs.loading.close();
      }
    },

    getData() {
      this.$vs.loading({
        container: "#div-with-loading",
        scale: 1.0,
        type: "sound",
      });

      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };

      http
        .get("/attendances/waivers", config)
        .then((result) => {
          this.$vs.loading.close("#div-with-loading > .con-vs-loading");
          this.dispensas = result.data.data;
        })
        .catch((error) => {
          error;
          this.$vs.loading.close("#div-with-loading > .con-vs-loading");
          if (error.response.status == 401) {
            this.$router.push("/").catch(() => {});
          }
        });
    },
    async saveData() {
  // Exibe o indicador de carregamento
  // this.$vs.loading({
  //   container: "#div-with-loading",
  //   scale: 1.0,
  //   type: "sound",
  // });
  this.$vs.loading();
  try {
    const token = localStorage.getItem("token");
    const config = {
      headers: {
        authorization: "Bearer " + token,
        "content-type": "multipart/form-data",
      },
    };

    const data = new FormData();
    data.append("employee_id", this.selectedEmployee.id);
    data.append("deduct_in", this.deduct_in);
    data.append("start_date", this.start_date);
    data.append("start_time", this.start_time);
    data.append("end_date", this.end_date);
    data.append("end_time", this.end_time);
    data.append("reason", this.reason);
    data.append("attachment", this.attachment);

    // Realiza a solicitação POST
    const response = await http.post("/attendances/waivers", data, config);

    // Verifique se a resposta tem o status 201
    if (response.status === 201) {
      // Fecha o popup e desativa o loading
      this.popupAdd = false;
      // this.$vs.loading.close("#div-with-loading > .con-vs-loading");
      this.$vs.loading.close();
      // Chama getData() e exibe notificação de sucesso
      this.getData();
      this.$vs.notify({
        title: "Sucesso",
        text: "Gravado com sucesso!",
        color: "success",
        position: "top-right",
      });
    }
  } catch (error) {
    // Verifica se há uma resposta do backend e exibe mensagem de erro
    this.err = (error.response && error.response.data) || "Ocorreu um erro. Tente novamente.";
    // this.$vs.loading.close("#div-with-loading > .con-vs-loading");
    this.$vs.loading.close();
    this.$vs.notify({
      title: "Erro",
      text: this.err,
      iconPack: "feather",
      icon: "icon-alert-circle",
      color: "danger",
      position: "top-right",
    });
  }
},

    popupOpenEdita(desconto) {
      (this.desconto = desconto), (this.popupEdit = true);
    },

    async editData() {
      //      this.$validator.validateAll().then(result => {
      // if (result) {
      this.$vs.loading();

      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };

      const data = {
        date: this.desconto.date,
        amount: this.desconto.amount,
        reason: this.desconto.reason,
      };

      this.$validator.validateAll();
      http
        .put(`/salaries/disconts/${this.desconto.discount_id}`, data, config)
        .then((success) => {
          success;
          (this.popupEdit = false), this.getData(), this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Actualizado com sucesso!",
            color: "success",
            position: "top-right",
          });
        })
        .catch((error) => {
          error;
        this.err = error.response.data;  
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          });
        });
      // }})
    },
    async removeData(desconto) {
      (this.desconto = desconto), this.$vs.loading();

      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };

      this.$validator.validateAll();
      http
        .delete(`/salaries/disconts/${this.desconto.discount_id}`, config)
        .then((success) => {
          success;
          (this.popupEdit = false), this.getData(), this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Removido com sucesso!",
            color: "success",
            position: "top-right",
          });
        })
        .catch((error) => {
          error;
          this.err = error.response.data;
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          });
        });
      // }})
    },
  },
};
</script>
